/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Progress_Tab_BodyInputs */

const en_features_progress_tab_body = /** @type {(inputs: Features_Progress_Tab_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Body`)
};

const pl_features_progress_tab_body = /** @type {(inputs: Features_Progress_Tab_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciało`)
};

/**
* | output |
* | --- |
* | "Body" |
*
* @param {Features_Progress_Tab_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_progress_tab_body = /** @type {((inputs?: Features_Progress_Tab_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Progress_Tab_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_progress_tab_body(inputs)
	return en_features_progress_tab_body(inputs)
});